// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateDataItemRequestModel from '../../model/update-data-item-request-model';
import UpdateDataItemRequestDTO from '../dto/update-data-item-request-dto';
import dtoSchema from '../schemas/update-data-item-request-schema';

export default abstract class UpdateDataItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateDataItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.creatorId = data.creatorId;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modified = data.modified ?? undefined;
      this.title = data.title ?? undefined;
      this.subTitle = data.subTitle ?? undefined;
      this.comment = data.comment ?? undefined;
      this.pictureDocumentExternalId = data.pictureDocumentExternalId ?? undefined;
      this.statusId = data.statusId;
      this.validFrom = data.validFrom ?? undefined;
      this.validUntil = data.validUntil ?? undefined;
      this.contentTypeId = data.contentTypeId ?? undefined;
      this.contentTypeUrl = data.contentTypeUrl ?? undefined;
      this.contentTypePath = data.contentTypePath ?? undefined;
      this.categoryId = data.categoryId;
      this.searchTerms = data.searchTerms ?? undefined;
      this.relatedLinkUrl = data.relatedLinkUrl ?? undefined;
      this.relatedLinkText = data.relatedLinkText ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  title?: string;
  /**
  */
  subTitle?: string;
  /**
  */
  comment?: string;
  /**
  */
  pictureDocumentExternalId?: string;
  /**
  * @type {int64}
  */
  statusId?: number;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validUntil?: string;
  /**
  * @type {int64}
  */
  contentTypeId?: number;
  /**
  */
  contentTypeUrl?: string;
  /**
  */
  contentTypePath?: string;
  /**
  * @type {int64}
  */
  categoryId?: number;
  /**
  */
  searchTerms?: string;
  /**
  */
  relatedLinkUrl?: string;
  /**
  */
  relatedLinkText?: string;

  static toModel(dto: DeepPartial<UpdateDataItemRequestDTO>): UpdateDataItemRequestModel;
  static toModel(dto: DeepPartial<UpdateDataItemRequestDTO> | undefined | null): UpdateDataItemRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateDataItemRequestDTO> | undefined | null): UpdateDataItemRequestModel | undefined {
    return dto ? new UpdateDataItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateDataItemRequestModel> | UpdateDataItemRequestModel): UpdateDataItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      creatorId: unwrapped.creatorId,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modified: unwrapped.modified,
      title: unwrapped.title,
      subTitle: unwrapped.subTitle,
      comment: unwrapped.comment,
      pictureDocumentExternalId: unwrapped.pictureDocumentExternalId,
      statusId: unwrapped.statusId,
      validFrom: unwrapped.validFrom,
      validUntil: unwrapped.validUntil,
      contentTypeId: unwrapped.contentTypeId,
      contentTypeUrl: unwrapped.contentTypeUrl,
      contentTypePath: unwrapped.contentTypePath,
      categoryId: unwrapped.categoryId,
      searchTerms: unwrapped.searchTerms,
      relatedLinkUrl: unwrapped.relatedLinkUrl,
      relatedLinkText: unwrapped.relatedLinkText,
    } as UpdateDataItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateDataItemRequestModel, can not map to UpdateDataItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
